import React, { forwardRef } from "react";
import { LoadingIndicator } from "@jsq/ds/core";
import { RemocalStatusIcon } from "../RemocalStatusIcon";
import * as styles from "./styles_vanilla.css";

export type RemocalPillProps = {
  isLoading: boolean;
  isCurrentSandboxReady: boolean;
  isBaseline: boolean;
  label: string;
  onOpen: () => void;
};

export const RemocalPill = forwardRef<HTMLButtonElement, RemocalPillProps>(
  ({ isLoading, isCurrentSandboxReady, isBaseline, label, onOpen }, ref) => (
    <button
      ref={ref}
      type="button"
      className={styles.pillStyle}
      aria-label="Open Remocal"
      onClick={onOpen}
      disabled={isLoading}
      title={
        isLoading
          ? "Loading sandboxes…"
          : !isBaseline && !isCurrentSandboxReady
            ? "Current sandbox is not ready, defaulting to baseline."
            : undefined
      }
    >
      {isLoading ? (
        <>
          <LoadingIndicator size="small" />
          <span className={styles.pillLabelStyle}>Remocal: Loading…</span>
        </>
      ) : (
        <>
          <RemocalStatusIcon
            isCurrentSandboxReady={isCurrentSandboxReady}
            isBaseline={isBaseline}
          />
          <span className={styles.pillLabelStyle}>Remocal: {label}</span>
        </>
      )}
    </button>
  ),
);

RemocalPill.displayName = "RemocalPill";
